export default __webpack_public_path__ + "static/media/2.21e2ed54.png";